import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';
import { baseUrl } from './routes';

interface Coordinate {
  latitude: number;
  longitude: number;
}

interface RoutePoint {
  routePathId: number;
  latitude: number;
  longitude: number;
  distance: number;
  checkpointId: number | null;
  orderLatLng: number;
  heading: number | null;
  isTrunkRoute: boolean;
  trunkCheckpointName: string | null;
  trunkCheckpointId: number | null;
}

interface ValidateTrunkRouteResponse {
  success: boolean;
  data: {
    totalPoints: number;
    trunkRoutePoints: number;
    matchPercentage: number;
    points: RoutePoint[];
  };
}

export const validateTrunkRouteService = async (
  coordinates: Coordinate[],
  configActions: ConfigActions = {}
): Promise<ValidateTrunkRouteResponse> => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post<ValidateTrunkRouteResponse>(`${baseUrl}/validateTrunkRoute`, {
    coordinates
  });
};
